/* eslint-disable(prettier/prettier) */
// 🔴 DO NOT EDIT — This file is generated.

import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
const BellAlertSvg = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g clipPath="url(#clip0_161_9843)">
      <path
        d="M10.9998 13.3333H4.6665C5.0298 13.1276 5.33971 12.8395 5.5713 12.4921C5.80288 12.1447 5.94967 11.7478 5.99984 11.3333V9.33333C6.03954 8.48738 6.3087 7.66818 6.77847 6.96353C7.24824 6.25888 7.9009 5.69535 8.6665 5.33333C8.6665 4.97971 8.80698 4.64057 9.05703 4.39052C9.30708 4.14048 9.64622 4 9.99984 4C10.3535 4 10.6926 4.14048 10.9426 4.39052C11.1927 4.64057 11.3332 4.97971 11.3332 5.33333C12.0988 5.69535 12.7514 6.25888 13.2212 6.96353C13.691 7.66818 13.9601 8.48738 13.9998 9.33333V10"
        stroke="currentColor"
        strokeWidth={1.33333}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 13.3335V14.0002C7.99999 14.3427 8.08799 14.6796 8.25554 14.9784C8.4231 15.2772 8.66461 15.528 8.95691 15.7067C9.24921 15.8853 9.58251 15.9859 9.92485 15.9988C10.2672 16.0117 10.6071 15.9364 10.912 15.7802"
        stroke="currentColor"
        strokeWidth={1.33333}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6668 12.6667L13.3335 14.6667H16.0002L14.6668 16.6667"
        stroke="currentColor"
        strokeWidth={1.33333}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_161_9843">
        <rect width={16} height={16} fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(BellAlertSvg)
export default ForwardRef
